import NoContent from 'features/settings/NoContent';
import TableError from 'features/settings/TableError';
import TableSkeleton from 'features/settings/TableSkeleton';
import type { SimulatedVehicleTO } from 'features/simulations-v2/types';

import SimulationsV2Row from './SimulationsV2Row';

export const tableHeaders = {
    vin: 'VIN',
    scenarioName: 'Scenario',
    state: 'State',
    startedAt: 'Started At',
};

interface Props {
    simulations: SimulatedVehicleTO[] | undefined;
    scenarioNames: Map<string, string>;
    isLoading: boolean;
    isError: boolean;
    refresh(): void;
}

const SimulationsV2Table = ({ simulations, scenarioNames, isLoading, isError, refresh }: Props) => {
    if (isLoading) {
        return <TableSkeleton id='simulations-v2' tableHeaders={tableHeaders} />;
    }

    if (isError) {
        return (
            <div className='TableContentWrapper'>
                <TableError
                    id='simulations-v2'
                    header='An error occurred while fetching simulations'
                    onClick={refresh}
                />
            </div>
        );
    }

    if (!simulations?.length) {
        return (
            <NoContent
                id='simulations-v2'
                title='No simulations yet'
                body='There are currently no active simulations.'
            />
        );
    }

    return (
        <div className='display-flex flex-column' data-testid='simulations-v2-table-wrapper'>
            <table data-testid='simulations-v2-table' className='table-head-filled table-hover table-bordered table'>
                <thead>
                    <tr>
                        {Object.values(tableHeaders).map(label => (
                            <th key={label} data-testid='simulations-v2-table-header'>
                                {label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {simulations.map(simulation => (
                        <SimulationsV2Row key={simulation.vin} simulation={simulation} scenarioNames={scenarioNames} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SimulationsV2Table;
